export const CommonDialogMaxWidth = 'min(450px, 95vw)';
export const CommonLargeDialogMaxWidth = 'min(850px, 95vw)';
